import type { Game } from "@/types";
import { getQuarterScores, getTeamById } from "@/utils/nba";

interface ScoreChartProps {
  game: Game;
}

export default function ScoreChart({ game }: ScoreChartProps) {
  const home = getTeamById(game.homeTeamId);
  const away = getTeamById(game.awayTeamId);
  const quarters = getQuarterScores(game);

  if (!home || !away) return null;

  if (quarters.length === 0) {
    return (
      <div className="rounded-lg border border-dashed border-background-300 bg-background-50 py-12 text-center text-sm text-foreground-500">
        比赛尚未开始，暂无比分节奏数据
      </div>
    );
  }

  const max = Math.max(...quarters.flatMap((item) => [item.home, item.away]), 1);

  return (
    <div className="rounded-lg border border-background-200 bg-background-50 p-4 md:p-5">
      <div className="mb-4 flex items-center gap-4">
        <span className="flex items-center gap-2 text-sm text-foreground-700">
          <span className="w-3 h-3 rounded-sm" style={{ backgroundColor: away.color }} />
          {away.fullName}
        </span>
        <span className="flex items-center gap-2 text-sm text-foreground-700">
          <span className="w-3 h-3 rounded-sm" style={{ backgroundColor: home.color }} />
          {home.fullName}
        </span>
      </div>

      <div className="flex items-end justify-around gap-3 h-52">
        {quarters.map((quarter) => (
          <div key={quarter.label} className="flex flex-1 flex-col items-center gap-2">
            <div className="flex w-full items-end justify-center gap-1.5 h-40">
              <div className="flex flex-col items-center justify-end h-full">
                <span className="mb-1 text-xs font-semibold text-foreground-700">{quarter.away}</span>
                <div
                  className="w-6 md:w-8 rounded-t-md transition-all"
                  style={{ backgroundColor: away.color, height: `${Math.max((quarter.away / max) * 100, 6)}%` }}
                />
              </div>
              <div className="flex flex-col items-center justify-end h-full">
                <span className="mb-1 text-xs font-semibold text-foreground-700">{quarter.home}</span>
                <div
                  className="w-6 md:w-8 rounded-t-md transition-all"
                  style={{ backgroundColor: home.color, height: `${Math.max((quarter.home / max) * 100, 6)}%` }}
                />
              </div>
            </div>
            <span className="text-xs text-foreground-500">{quarter.label}</span>
          </div>
        ))}
      </div>
    </div>
  );
}